import React from 'react';

export const AddTimeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5432 10.37H11.36L11.36 7.05955H9.78105V11.8217H14.5432L14.5432 10.37Z" fill="#444D55" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2C6.0284 2 2 6.0293 2 11C2 15.9716 6.0293 20 11 20C11.7942 20 12.5644 19.8972 13.2979 19.7041C13.1051 19.1723 13 18.5984 13 18C13 17.9721 13.0002 17.9443 13.0007 17.9165C12.3561 18.1029 11.683 18.2 11 18.2C9.09044 18.2 7.25909 17.4414 5.90883 16.0912C4.55857 14.7409 3.8 12.9096 3.8 11C3.8 9.09044 4.55857 7.25909 5.90883 5.90883C7.25909 4.55857 9.09044 3.8 11 3.8C12.9096 3.8 14.7409 4.55857 16.0912 5.90883C17.4414 7.25909 18.2 9.09044 18.2 11C18.2 11.683 18.1029 12.3561 17.9165 13.0007C17.9443 13.0002 17.9721 13 18 13C18.5984 13 19.1722 13.1051 19.7041 13.2979C19.8972 12.5644 20 11.7942 20 11C20 6.0284 15.9707 2 11 2Z"
      fill="#444D55"
    />

    <path
      d="M17 17V15.5C17 15.2 17.2 15 17.5 15H18.5C18.8 15 19 15.2 19 15.5V17H20.5C20.8 17 21 17.2 21 17.5V18.5C21 18.8 20.8 19 20.5 19H19V20.5C19 20.8 18.8 21 18.5 21H17.5C17.2 21 17 20.8 17 20.5V19H15.5C15.2 19 15 18.8 15 18.5V17.5C15 17.2 15.2 17 15.5 17H17Z"
      fill="#444D55"
    />
  </svg>
);
